<template>
  <div class="warnSignGenerate">
    <top :toolSort="toolSort"></top>
    <!-- 占空间 -->
    <div class="toolDesc"></div>

    <!-- 具体工具模块 -->
    <div :class="['toolMain',{mobileFontSize:$isMobile}]">
      <!--need sortList keyWordObj -->
      <!--have checkSort checkList -->
      <div class="harmfulTable">
        <div class="select">
          <el-radio :label="0" v-model="checkSort">全部</el-radio>
          <el-radio v-model="checkSort" v-for="(item,i) in sortList" :key="i" :label="item">{{item}}</el-radio>
          <el-input size='mini' v-model="searchKeys" clearable type placeholder="请输入关键字" @input="findKeywords">
                    <i class="el-icon-search" type="primary" @click="findKeywords" slot='suffix'></i>

          </el-input>
        </div>
        <div class="keywordList">
          <div
            v-show="value!=undefined&&value.length"
            class="keywordItem"
            v-for="(value,key,index) in keyWordObj"
            :key="index"
          >
            <div :class="['firstPin',{mobileFontSize:$isMobile}]">
              <span>{{key}}</span>
            </div>
            <el-checkbox-group v-model="checkList">
              <el-checkbox :label="item.keyword" v-for="(item,i) in value" :key="i"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <!-- 关键词部分 没有更多的参数 -->
    <div :class="['keyWord',{mobileFontSize:$isMobile}]">
      <div :class="['keywordLabel',{mobileFontSize:$isMobile}]">关键词：</div>
      <span v-show="checkList!=undefined&&checkList.length===0">暂未选择关键词</span>
      <el-tag
        type="info"
        @close="closeTag(i)"
        v-for="(tag,i) in checkList"
        :key="i"
        closable
      >{{tag}}</el-tag>
    </div>
    <div class="listGroup">
        <!-- 是否在岗之类的东西 -->
      <!-- <el-select :class="{mobileFontSize:$isMobile}" v-model="status" placeholder="请选择">
        <el-option v-for="(item,i) in statusList" :key="i" :label="item" :value="item"></el-option>
      </el-select> -->
      <!-- 推荐结果 -->
      <el-button type="primary" @click="getExamRes" size="mini">推荐结果</el-button>
      <el-button type="warning" plain="" size="mini" @click='checkList = []'>清空关键词</el-button>
      <el-button plain="" size="mini" disabled v-if="disabled" >合并表格</el-button>
      <el-button plain="" size="mini" @click='merge' v-else :disabled='!testResult[0]'>合并表格</el-button>
      <el-button plain="" @click="getPdf()" size="mini" :disabled='!testResult[0]'>导出pdf</el-button>

    <!-- excel表格 -->
    
      <div id="pdfdom" class="pdfdom">
        <h5 class="tableTitle">有害因素对应的警示语句和图形标识--{{new Date().toLocaleString("chinese",{ year: "numeric", month: "2-digit",
            day: "2-digit" })}}
        </h5>
         <!-- PC端 -->
        <!-- <el-table id="examTable" v-show="showRes&&!$isMobile" :highlight-current-row='true' :data='testResult' :border="true"> -->
        <el-table size="mini" v-if="merges" id="examTable" v-show="showRes&&!$isMobile" :highlight-current-row='true' :data='testResult' :border="true" :span-method="objectSpanMethod">
          <el-table-column fixed align='center' prop="keyword" label="危害因素或作业"></el-table-column>
          <el-table-column align='center' prop="signList[0]" label="类目1">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[0]" >
                <img :src="scope.row.signList[0][0]" alt="" srcset="" class="signImage">
                <br>
                <span>{{scope.row.signList[0][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[1]" label="类目2">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[1]" >
                <img :src="scope.row.signList[1][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[1][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[2]" label="类目3">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[2]" >
                <img :src="scope.row.signList[2][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[2][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[3]" label="类目4">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[3]" >
                <img :src="scope.row.signList[3][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[3][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[4]" label="类目5">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[4]" >
                <img :src="scope.row.signList[4][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[4][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[5]" label="类目6">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[5]" >
                <img :src="scope.row.signList[5][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[5][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[6]" label="类目7">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[6]" >
                <img :src="scope.row.signList[6][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[6][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[7]" label="类目8">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[7]" >
                <img :src="scope.row.signList[7][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[7][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[8]" label="类目9">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[8]" >
                <img :src="scope.row.signList[8][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[8][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else id="examTable" v-show="showRes&&!$isMobile" :highlight-current-row='true' :data='testResult' :border="true">
          <el-table-column fixed align='center' prop="keyword" label="危害因素或作业"></el-table-column>
          <el-table-column align='center' prop="signList[0]" label="类目1">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[0]" >
                <img :src="scope.row.signList[0][0]" alt="" srcset="" class="signImage">
                <br>
                <span>{{scope.row.signList[0][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[1]" label="类目2">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[1]" >
                <img :src="scope.row.signList[1][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[1][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[2]" label="类目3">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[2]" >
                <img :src="scope.row.signList[2][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[2][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[3]" label="类目4">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[3]" >
                <img :src="scope.row.signList[3][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[3][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[4]" label="类目5">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[4]" >
                <img :src="scope.row.signList[4][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[4][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[5]" label="类目6">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[5]" >
                <img :src="scope.row.signList[5][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[5][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[6]" label="类目7">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[6]" >
                <img :src="scope.row.signList[6][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[6][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[7]" label="类目8">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[7]" >
                <img :src="scope.row.signList[7][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[7][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[8]" label="类目9">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[8]" >
                <img :src="scope.row.signList[8][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[8][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 移动端 -->
        <el-table
        size="mini"
          class="mobileTable"
          v-show="showRes&&$isMobile"
            :data="testResult"
            style="width: 100%">
          <el-table-column fixed align='center' prop="keyword" label="危害因素或作业"></el-table-column>
          <el-table-column align='center' prop="signList[0]" label="类目1">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[0]" >
                <img :src="scope.row.signList[0][0]" alt="" srcset="" class="signImage">
                <br>
                <span>{{scope.row.signList[0][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[1]" label="类目2">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[1]" >
                <img :src="scope.row.signList[1][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[1][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[2]" label="类目3">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[2]" >
                <img :src="scope.row.signList[2][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[2][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[3]" label="类目4">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[3]" >
                <img :src="scope.row.signList[3][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[3][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[4]" label="类目5">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[4]" >
                <img :src="scope.row.signList[4][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[4][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[5]" label="类目6">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[5]" >
                <img :src="scope.row.signList[5][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[5][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[6]" label="类目7">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[6]" >
                <img :src="scope.row.signList[6][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[6][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[7]" label="类目8">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[7]" >
                <img :src="scope.row.signList[7][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[7][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column align='center' prop="signList[8]" label="类目9">
            <template slot-scope="scope" >
              <div  v-if="scope.row.signList[8]" >
                <img :src="scope.row.signList[8][0]" alt="" class="signImage">
                <br>
                <span>{{scope.row.signList[8][1]}}</span>
              </div>
              <span v-else> </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../subComponents/top.vue";
import orderByFirstPin from "@/util/oderByFirstPin.js";

const cate2SignList = {
  "化学因素":["当心中毒","当心腐蚀","当心有毒气体","戴防护镜","戴防毒面具","戴防护手套","穿防护服","穿防护鞋","注意通风"],
  "粉尘":["注意防尘","戴防尘口罩","注意通风",null,null,null,null,null,null],
  "物理因素":[null,null,null,null,null,null,null,null,null],
   "生物因素":["当心感染",null,null,null,null,null,null,null,null]
}
const item2SignList = {
  "噪声":["噪声有害","戴护耳器",null,null,null,null,null,null,null],
  "高温":["注意高温",null,null,null,null,null,null,null,null],
  "紫外辐射(紫外线)":["当心弧光","当心电离辐射","穿防护服","戴防护镜",null,null,null,null,null]
}
const str2ImageObject = (cate2SignList)=>{
  Object.keys(cate2SignList).forEach(key=>{
    cate2SignList[key] = cate2SignList[key].map(item=>{
      if(item === null){
        return;
      }else{
        return [require("@/assets/images/warnSign/"+item+".png"),item]
      }
    })
  })
}
str2ImageObject(cate2SignList)
str2ImageObject(item2SignList)

export default {
  components: {
    top,// 生成描述 需要toolSort
  },
  created(){
    // 描述
    this.toolSort = this.$route.params.sort
    // 获得所有的关键词
    this.getAllKeyword()
    document.onkeydown = e => {
      let key = window.event.keyCode
      if (key === 13) {
        this.findKeywords()
      }
    }
  },
  data(){
      return {
        htmlTitle:"",
        nowTime:(new Date()).getTime(),
        toolSort: null,
        // resultStatus: '', //体检结果状态 ---上岗前，在岗，离岗
        // statusList: ["上岗前", "在岗", "离岗"],
        // status: "在岗",
        checkSort: 0, //被选中的关键词分类
        sortList: ["化学因素", "粉尘", "物理因素", "生物因素"],
        searchKeys: '',
        selectTool: '',
        showRes: false, //显示推荐结果表格
        checkList: [],
        keyWordObj: {},
        testResult: [], // 推荐的结果,里面包含keyword和signList
        spanArr: [],   //存放每一行记录的合并数
        position: 0,   //spanArr的索引
        merges:false,
        disabled:false,
        input:"",
      }
  },
  watch: {
    checkSort(newVal) {
      // console.log(this.checkSort)
      this.findKeywords()
    },
    searchKeys(newVal) {
      if (!newVal) this.findKeywords()
    }
  },
    // updated(){
    //     this.rowspan()
    // },
  methods:{
    // 合并表格
    merge(){
      // 调用判断this.spanArr数组的那个方法，定义每一行的 rowspan
      this.merges = true;
      this.disabled = true;
      this.rowspan();
    },
    rowspan() {
           this.testResult.forEach((item,index) => {
             if( index === 0){
                 this.spanArr.push(1);
                 this.position = 0;
             }else{
              //  让下一行与上一行作比较
                 if(this.testResult[index].signList[0] === this.testResult[index-1].signList[0] ){
                     this.spanArr[this.position] += 1;
                     this.spanArr.push(0);
                 }else{
                     this.spanArr.push(1);
                     this.position = index;
                 }
             }
         })
       },
     objectSpanMethod({ row, column, rowIndex, columnIndex }) {  //表格合并行
        // row是当前行，column是当前列，rowIndex是当前行的索引，columnIndex是当前列的索引
         if(columnIndex === 1){
             const _row = this.spanArr[rowIndex];  //合并行的行数，1代表独占一行，比1大代表合并若干行，0代表不显示
             const _col = _row>0 ? 1 : 0;   //行如果存在那么列就存在，行不存在那么列也就不存在
             return {
                 rowspan: _row,
                 colspan: _col
             }
         }
         if(columnIndex === 2){
             const _row = this.spanArr[rowIndex];
             const _col = _row>0 ? 1 : 0;
             return {
                 rowspan: _row,
                 colspan: _col
             }
         }
         if(columnIndex === 3){
             const _row = this.spanArr[rowIndex];
             const _col = _row>0 ? 1 : 0;
             return {
                 rowspan: _row,
                 colspan: _col
             }
         }
         if(columnIndex === 4){
             const _row = this.spanArr[rowIndex];
             const _col = _row>0 ? 1 : 0;
             return {
                 rowspan: _row,
                 colspan: _col
             }
         }
         if(columnIndex === 5){
             const _row = this.spanArr[rowIndex];
             const _col = _row>0 ? 1 : 0;
             return {
                 rowspan: _row,
                 colspan: _col
             }
         }
         if(columnIndex === 6){
             const _row = this.spanArr[rowIndex];
             const _col = _row>0 ? 1 : 0;
             return {
                 rowspan: _row,
                 colspan: _col
             }
         }
         if(columnIndex === 7){
             const _row = this.spanArr[rowIndex];
             const _col = _row>0 ? 1 : 0;
             return {
                 rowspan: _row,
                 colspan: _col
             }
         }
         if(columnIndex === 8){
             const _row = this.spanArr[rowIndex];
             const _col = _row>0 ? 1 : 0;
             return {
                 rowspan: _row,
                 colspan: _col
             }
         }
         if(columnIndex === 9){
             const _row = this.spanArr[rowIndex];
             const _col = _row>0 ? 1 : 0;
             return {
                 rowspan: _row,
                 colspan: _col
             }
         }
     },

      async getAllKeyword() {
          // 这里需要修改 它的接口 可能
        let res = await this.$axios.get(this.$serviceAPI.findAllExam)
        // order的功能是什么？
        this.keyWordObj = orderByFirstPin(res.data.data, 'keyword')
      },

      //条件查询危害因素关键字
      async findKeywords() {
          // 通过后端请求来实现范围查询
        let res = await this.$axios.post(this.$serviceAPI.findKeywords, {
          keyword: this.searchKeys,
          sort: this.checkSort
        })
        if (res.data.data && res.data.data.length === 0) {
          this.message({
            message: '暂无数据，换个关键词试试吧',
            type: 'error'
          })
        }
        this.keyWordObj = orderByFirstPin(res.data.data, 'keyword')
      },
      // 推荐结果的click函数
      getExamRes() {
        this.showRes = true
        this.$axios.post(this.$serviceAPI.findListsByKeywordWithWarnSign, {
          keywords: this.checkList,
          // status: this.status
        }).then(res => {
          this.testResult = res.data.data
          // console.log(this.testResult);
          // 如果在item2SortList里面
          // 如果不在item2SortList
          this.testResult = this.testResult.map(item=>{
  //           "噪声":["噪声有害","戴护耳器",null,null,null,null,null,null,null],
  // "高温":["注意高温",null,null,null,null,null,null,null,null],
  // "紫外辐射(紫外线)":["当心弧光","当心电离辐射","穿防护服","戴防护镜",null,null,null,null,null]
            if(item2SignList[item.keyword]){
              return {"keyword":item.keyword,"signList":item2SignList[item.keyword]}
            }else{
              return {"keyword":item.keyword,"signList":cate2SignList[item.sort]}
            }
          })
          this.htmlTitle = `有害因素对应的警示语句和图形标识--${new Date().toLocaleString("chinese",{ year: "numeric", month: "2-digit",
            day: "2-digit" })}`
          // 再次添加关键词时清除之前的数据
          this.spanArr = [];
          this.position = 0;
          this.merges = false;
          this.disabled = false;
        })
      },
      // 
      topdf(){
         htmlToPdf.ExportSavePdf(this.htmlTitle,this.nowTime)
      },
      // 关键词里面的东西 关闭关键词
      closeTag(i) {
        this.checkList.splice(i, 1)
      },
  }
};
</script>

<style scoped="scoped">
  @import url("../../assets/iconfont.css");
  .signImage{
    width:40px;
  }

  @media print {}
  /* 专用的打印样式 */
  @page {
    /* size: auto; //默认的*/
    size: 10cm 25cm; /* 纸张大小 */
    /* size: A4 landscape; portrait/landscape //使用系统中的纸张和方向 */
    margin: 0; /* 清除打印文档的边距 */
    height: 100%;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .tableTitle{
    text-align: center;
    display: none;
  }
  .el-radio{
    margin-right: 1rem;
  }
  /* .el-button+.el-button{
    margin-left: 0;
    margin-bottom: 0.5625rem;
  }
  .el-button{
    margin-bottom: 0.625rem;
  } */
  .keywordItem {
    display: flex;
  }

  .keywordList {
    max-height: 8rem;
    overflow: scroll;
    width: 100%;
  }


  .firstPin {
    font-size: 14px;
    color: #777;

    margin-right: 1.25rem;
  }

  .top {
    width: 66.875rem;
  }

  .iconsousuo {
    cursor: pointer;
    float: right;
  }
  .el-input__inner{
    height: 2rem !important;
  }


  .el-input {
    width: 9rem;
    font-size: 14px;
    margin-bottom: 0.325rem;
  }

  .el-input__inner {
    height: 1.9375rem;
    line-height: 1.9375rem;
  }
  .el-tag{
    line-height: 1.5rem;
    height: 1.5rem;
  }
  .toolMain {
    margin-top: 1.25rem;
  }

  /* .el-button {
    padding: 0.4375rem 0.625rem;
  } */

  .iconlinecar105 {
    font-size: 12px;
  }

  .harmfulTable {
    line-height: 2rem;
    margin-top: 1.25rem;
    padding-left: 1.1rem;
    border: 1px solid #EEEEEE;
    background: whitesmoke;
  }
  .keywordLabel{
    display: inline-block;
  }
  .keyWord {
    /* display: flex;
    align-items: center; */
    margin-top: 1.25rem;
    font-size: 14px;
    color: #666;
    padding-bottom: 1.25rem;
    padding-left: 0.1875rem;
    padding-bottom: .6rem;
    width: 100%;
    white-space: pre-line;
  }


  .el-tag.el-tag--info {
    margin-right: 1rem;
    margin-bottom: 0.625rem;
  }

  .el-table {
    margin-top: 1.25rem;
  }
  /* 警示标识部分的样式 */
  .pdfdom{
    text-align: center;
  }
  .imgHazard{
    width: 400px;
    height: 100px;
    display: inline-block;
    margin-right: 10px;
  }
  .imgHazard>div{
    width: 50%;
    height: 100%;
    line-height: 100px;
    float: left;
    text-align: center;
  }
  .imgHazard_left{
    background-color: rgb(224, 243, 245);
  }
  .imgHazard_right{
    background-color: rgb(245, 245, 245);
  }
  .imgHazard_right>img{
    width: 70px;
    height: 70px;
    background-color: cyan;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/subPage/warnSignGenerate.vue